(function () {
  const modalSelector = 'xflow-modal[id^="xflow-bis-modal-"]';
  const root = document.documentElement;
  let activeModal = null;
  let scrollPosition = null;

  function updateViewport() {
    if (!activeModal) return;
    const viewport = window.visualViewport;
    activeModal.style.setProperty('--surma-bis-viewport-height', `${viewport ? viewport.height : window.innerHeight}px`);
    activeModal.style.setProperty('--surma-bis-viewport-top', `${viewport ? viewport.offsetTop : 0}px`);
  }

  function restorePage() {
    if (!activeModal) return;
    window.removeEventListener('resize', updateViewport);
    window.visualViewport?.removeEventListener('resize', updateViewport);
    window.visualViewport?.removeEventListener('scroll', updateViewport);
    activeModal.style.removeProperty('--surma-bis-viewport-height');
    activeModal.style.removeProperty('--surma-bis-viewport-top');
    activeModal = null;
    root.classList.remove('surma-bis-open');
    root.style.removeProperty('--surma-bis-scroll-top');
    window.scrollTo({ left: scrollPosition.x, top: scrollPosition.y, behavior: 'instant' });
    scrollPosition = null;
  }

  function openModal(modal) {
    if (!modal?.matches(modalSelector) || activeModal) return;
    activeModal = modal;
    scrollPosition = { x: window.scrollX, y: window.scrollY };
    root.style.setProperty('--surma-bis-scroll-top', `${-scrollPosition.y}px`);
    root.classList.add('surma-bis-open');

    updateViewport();
    window.addEventListener('resize', updateViewport);
    window.visualViewport?.addEventListener('resize', updateViewport);
    window.visualViewport?.addEventListener('scroll', updateViewport);
  }

  customElements.whenDefined('xflow-modal').then(() => {
    const { pubSub, vars } = window.XFLOW;
    pubSub.subscribe(vars.events.modalShow, ({ element }) => openModal(element));
    pubSub.subscribe(vars.events.modalHide, ({ element }) => {
      if (element === activeModal) restorePage();
    });
    openModal(document.querySelector(`${modalSelector}[open]`));
  });

  window.addEventListener('pagehide', restorePage);
  window.addEventListener('pageshow', () => {
    openModal(document.querySelector(`${modalSelector}[open]`));
  });
})();
